// const BASE_URL = 'https://riverlandings-backend.herokuapp.com/';
const BASE_URL = 'https://api.riverlandings.dev.stickboy.co/';

export default {
  BASE_URL,
};
